import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Alert, AlertService } from '@michelin/theme';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { DealershipFormComponent } from '../components/dealership-form/dealership-form.component';
import { DealershipService } from 'src/app/shared/services/dealership/dealership.service';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { ProductLineService } from 'src/app/shared/services/product-line/product-line.service';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';

@Component({
    selector: 'app-create-dealership',
    templateUrl: './create-dealership.component.html',
    standalone: false
})
export class CreateDealershipComponent implements OnInit {
  loading: boolean = false;

  data = {
    automakers: [] as AutomakerDto[],
    states: [] as StateDto[],
    productLines: [] as ProductLineDto[]
  };

  @ViewChild(DealershipFormComponent) dealershipForm: DealershipFormComponent;

  constructor(
    private readonly dealershipService: DealershipService,
    private readonly automakerService: AutomakerService,
    private readonly distrubutorService: DistributorService,
    private readonly locationService: LocationService,
    private readonly productLineService: ProductLineService,
    private readonly alertService: AlertService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.loading = true;

    forkJoin({
      automakers: this.automakerService.findAll(),
      states: this.locationService.findAllStates(),
      productLines: this.productLineService.findAll()
    })
      .subscribe({
        next: (result) => (this.data = result),
        error: () =>
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao recuperar as informações'
          } as Alert)
      })
      .add(() => (this.loading = false));
  }

  submitForm() {
    this.loading = true;
    this.dealershipService
      .create(this.dealershipForm.formValues)
      .subscribe({
        next: () => {
          this.router.navigate(['/dealerships']).then(() =>
            this.alertService.showAlert({
              type: 'success',
              content: 'Concessionária cadastrada com sucesso'
            } as Alert)
          );
        },
        error: () =>
          this.alertService.showAlert({
            type: 'critical',
            content: 'Ocorreu um erro ao cadastrar a concessionária'
          } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
